import { gql } from '@apollo/client';

export const SITE_ENTITY_SEARCH_BY_ID = gql`
    query siteEntitySearchById(
        $processFilter: ProcessFilter
        $processVariableFilter: VariableFilter
        $processSchemaFilter: ProcessSchemaFilter
    ) {
        facility {
            id
            processes(filter: $processFilter) {
                id
                name
                description
                type
            }

            processVariables(filter: $processVariableFilter) {
                id
                name
                description
                process {
                    id
                }
            }

            processSchemas(filter: $processSchemaFilter) {
                id
                name
                process {
                    id
                }
            }
        }
    }
`;
